export enum ActionView {
  Icon = 'ICON',
  Button = 'BUTTON'
}
